import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Header";
import NumberedCards from "../../Components/NumberedCrads";
import Pricing from "../../Components/PricingTable";
import bgplans from "../../Images/Frame.png";
import graphicservice from "../../Images/Graphics PNG/graphicManagementservice.png";
import img3 from "../../Images/SocialMediaMng/Audience Engagement.jpg";
import img6 from "../../Images/SocialMediaMng/Competitor Monitoring.jpg";
import img2 from "../../Images/SocialMediaMng/Content Scheduling & Posting.jpg";
import img1 from "../../Images/SocialMediaMng/Profile Setup & Optimization.jpg";
import img4 from "../../Images/SocialMediaMng/Reputation Management.jpg";
import img5 from "../../Images/SocialMediaMng/Social Media Analytics.jpg";

const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];

const SocialMediaManagement = () => {
  const [currentWord, setCurrentWord] = useState(0);
  const [animate, setAnimate] = useState(false);

  const cardsData = [
    {
      title: "Profile Setup & Optimization",
      description: [
        "Account Creation & Setup",
        "Profile Optimization (Bio, Profile Picture, Links)",
        "Branding & Visual Identity Alignment",
        "Custom Cover & Profile Graphics",
      ],
      Icon: img1,
    },
    {
      title: "Content Scheduling & Posting",
      description: [
        "Content Calendar Creation",
        "Automated Scheduling & Posting",
        "Platform-Specific Content Adaptation",
        "Consistent Posting Frequency",
      ],
      Icon: img2,
    },
    {
      title: "Audience Engagement",
      description: [
        "Daily Monitoring & Engagement",
        "Responding to Comments & Messages",
        "Proactive Audience Interaction",
        "Building Relationships with Followers",
      ],
      Icon: img3,
    },
    {
      title: "Reputation Management",
      description: [
        "Monitoring Brand Mentions",
        "Addressing Negative Feedback",
        "Crisis Management & Response",
        "Building Positive Brand Sentiment",
      ],
      Icon: img4,
    },
    {
      title: "Social Media Analytics",
      description: [
        "Monthly Performance Reporting",
        "Audience Growth & Engagement Metrics",
        "Content Performance Analysis",
        "Recommendations for Improvement",
      ],
      Icon: img5,
    },
    {
      title: "Competitor Monitoring",
      description: [
        "Analysis of Competitor Activities",
        "Competitive Insights & Benchmarking",
        "Adapting Strategies Based on Competitor Success",
      ],
      Icon: img6,
    },
  ];

  const plans = [
    {
      name: "Basic",
      description:
        "A perfect starter package to setup your profile with essential elements. Includes daily profile monitoring, regular content posting etc.",
      features: [
        "Profile Monitoring: Daily monitoring of social media profiles.",
        "Content Posting: Posting of pre-approved content 3-4 times per week.",
        "Basic Engagement: Responding to comments and direct messages.",
        "Monthly Insights: Overview report with key metrics.",
      ],
    },

    {
      name: "Standard",
      description:
        "Enhance your profile with comprehensive design assets and detailed guidelines. We will report you with the performance analysis.",
      features: [
        "Profile Monitoring & Management: Daily monitoring and management of profiles.",
        "Content Scheduling & Posting: Scheduled posting of content 5 times per week.",
        "Engagement & Interaction: Responding to comments, messages, and proactive engagement.",
        "Monthly Insights & Reporting: Detailed monthly report with performance analysis.",
      ],
      popular: true,
    },

    {
      name: "Premium",
      description:
        "Comprehensive content and profile management solutions with detail reporting and advance interaction ",
      features: [
        "Comprehensive Profile Management: Daily monitoring, management, and optimization.",
        "Content Scheduling & Posting: Scheduled posting of content daily.",
        "Advanced Engagement & Interaction: Proactive engagement, customer support, and reputation management.",
        "Competitor Analysis: Regular monitoring and analysis of competitor activity.",
        "Monthly Insights, Reporting & Strategy Review: In-depth monthly report with strategic recommendations and competitor insights.",
      ],
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);

      setTimeout(() => {
        setCurrentWord((prevWord) => (prevWord + 1) % words.length);
        setAnimate(false);
      }, 500);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="md:snap-y md:snap-mandatory md:h-screen md:overflow-y-scroll lg:snap-y lg:snap-mandatory lg:h-screen lg:overflow-y-scroll">
      <div className="lg:snap-start lg:h-screen md:snap-start md:h-screen ">
        <div className="">
          <Navbar color={"bg-teal-950 text-white"} />
        </div>

        {/* Animated Text Section */}
        <div className="flex flex-col justify-between">
          <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row gap-8 pb-20 lg:pt-12">
            {/* Left Side: Text Section */}
            <div className="flex flex-col justify-center w-full lg:w-1/2 md:w-1/2 mt-6 md:mt-6 lg:mt-10">
              <h1 className="relative h-12 mb-2 md:mb-4 lg:mb-4">
                <span
                  className={`absolute transition-transform duration-500 ease-in-out text-xl md:text-3xl lg:text-4xl font-bold text-teal-500`}
                >
                  {words[currentWord]}
                </span>
              </h1>
              <h2
                className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-teal-800
              "
              >
                Social Media Management Services
              </h2>
              <p className="text-gray-600 mb-8 text-md md:text-lg lg:text-lg">
                Ignite the force of visual storytelling, from bespoke
                illustrations to captivating infographics, our talented artists
                sculpt mesmerizing designs that deeply connect with your
                audience and amplify your brand's message.
              </p>
            </div>

            {/* Right Side: Image Section */}
            <div className=" hidden md:flex lg:flex justify-center items-center w-full lg:w-1/2 md:w-1/2 mt-10 md:mt-0 lg:mt-0">
              <img
                src={graphicservice}
                alt="Illustration Design"
                className="w-[250px] h-[250px] md:w-[400px] md:h-[350px] lg:w-[500px] lg:h-[500px]"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Numbered Cards Section */}
      <div className="lg:snap-start lg:h-screen  md:snap-start md:h-screen">
        <NumberedCards cardsData={cardsData} />
      </div>

      {/* Pricing Section */}
      <div className="lg:snap-start md:snap-start">
        <div
          className="w-full  mx-auto  "
          style={{
            backgroundImage: `url(${bgplans})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <Pricing plans={plans} />
        </div>
      </div>

      {/* Footer */}
      <div className="lg:snap-start md:snap-start">
        <Footer />
      </div>
    </div>
  );
};

export default SocialMediaManagement;
